/* eslint-disable react/no-direct-mutation-state */
import React, {Component }  from "react";
//import { variables } from './Variables.js';
import TransMap from "./TransMap.js";
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';

export class Trip extends Component {
    constructor(props) {
        super(props);

        this.state = {    
            locdata: {
                longitude: 0,
                latitude: 0,
                address: '',
            }
        };
        
    }

    async refreshList() {

        this.state.locdata.latitude.value = 0;
        this.state.locdata.longitude.value = 0;
        this.state.locdata.address.value = '';

        //await fetch(variables.API_URL + 'mandat3')
        //    .then(response => response.json())
        //    .then(data => {
        //        data.sort();
        //        this.setState({ votes: data, loading: false })
        //    });
    }

    getLonLat (long,lat,addr) {
        //alert(long+ ":" + lat);
        document.getElementById("reslongitude").value = long; //this.state.locdata.longitude;
        document.getElementById("reslatitude").value = lat; //this.state.locdata.latitudelat;
        document.getElementById("resaddress").value = addr;// this.state.locdata.address;
    }

    componentDidMount() {
        this.refreshList();
    }

   
    async createClick () {
       
        let mylong = (this.state.locdata.longitude.value).trim();
        let mylat = (this.state.locdata.latitude.value).trim();
        let myaddr = (this.state.locdata.address.value).trim();
        console.log(mylong);
        console.log(mylat);
        console.log(myaddr);
    }

   

    render() {
        const {
            locdata
        } = this.state;



        return (
            <div style={{ width: "100%"}}>
                <div className="container">
                    <div className="container mb-3" style={{ width: '100%' }}>
                        <TransMap getData={this.getLonLat} reslong={locdata.longitude} reslat={locdata.latitude} resaddr={locdata.address} />
                    </div>
                    <div className="container" style={{ width: '100%' }}>
                        {/*<p>*/}
                        {/*    <button className="btn btn-warning" type="button" data-bs-toggle="collapse" data-bs-target="#collapseWidthLongLat" aria-expanded="false" aria-controls="collapseWidthLongLat">*/}
                        {/*        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">*/}
                        {/*            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />*/}
                        {/*        </svg>*/}
                        {/*        <span>COORDONNEES GEOGRAPHIQUES</span>*/}
                        {/*    </button>*/}
                        {/*</p>*/}
                        {/*<div className="collapse collapse-horizontal" id="collapseWidthLongLat">*/}
                        <div className="input-group mb-3" style={{ width: '100%' }}>
                                <span className="input-group-text">Longitude</span>
                                <span><input type="number" id="reslongitude" className="form-control"
                                    ref={(input) => (this.state.locdata.longitude = input)} disabled /></span>
                                {/* <input type="number" className="form-control" id="reslongitude"
                                                value={Longitude}
                                                onChange={this.changeLongitude} /> */}
                            </div>
                        <div className="input-group mb-3" style={{ width: '100%' }}>
                                <span className="input-group-text">Latitude</span>
                                <span><input type="number" id="reslatitude" className="form-control"
                                    ref={(input) => (this.state.locdata.latitude = input)} disabled /></span>
                                {/* <input type="number" className="form-control" id="reslatitude"
                                                value={Latitude}
                                                onChange={this.changeLatitude} /> */}
                        </div>
                        <div className="input-group mb-3" style={{width:'100%', fontSize:'0.8rem'} }>
                            <span className="input-group-text">Address</span>
                            <span><input type="text" id="resaddress" className="form-control" style={{width:'300px', wordWrap:true} }
                                ref={(input) => (this.state.locdata.address = input)} /></span>
                        </div>

                        {/*</div>*/}
                    </div>
                    <button type="button" className="btn btn-primary float-start"
                        onClick={() => this.createClick()}>
                        Saisir
                    </button>
                </div>
                {/*<ToastContainer />*/}
            </div>
        )
    }
}